"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _theme = require("../../../theme");
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _FormModal = _interopRequireDefault(require("../../../components/Modals/FormModal"));
var _ModularFlexForm = _interopRequireDefault(require("./ModularFlexForm"));
var _Loader = _interopRequireDefault(require("../../../components/Loader"));
var _Tooltip = _interopRequireDefault(require("../../../components/Tooltip"));
var _ArrowBackRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackRounded"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var Services = _interopRequireWildcard(require("../../../services"));
var _DateInput = _interopRequireDefault(require("../../../components/TextFields/DateInput"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ModularFlexDesignForm = /*#__PURE__*/function (_Component) {
  function ModularFlexDesignForm() {
    var _this;
    (0, _classCallCheck2["default"])(this, ModularFlexDesignForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, ModularFlexDesignForm, [].concat(args)), _this.state = {
      unSavedChangesMade: false,
      showSaveMessageDialog: false,
      effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
      showEffectiveDateDialog: false,
      errors: {
        health: {
          gold: {
            healthcare: {},
            drugs: {},
            spendingAccounts: {}
          },
          silver: {
            healthcare: {},
            drugs: {},
            spendingAccounts: {}
          },
          bronze: {
            healthcare: {},
            drugs: {},
            spendingAccounts: {}
          }
        },
        dental: {
          gold: {},
          silver: {},
          bronze: {}
        },
        outOfCountry: {},
        efap: {},
        virtualHealthcare: {},
        financialAwareness: {},
        lifeInsurance: {},
        deathDismemberment: {},
        std: {},
        ltd: {},
        criticalIllness: {},
        dependentLife: {}
      }
    }, _this._setChangesMadeFlag = function () {
      _this.setState({
        unSavedChangesMade: true
      });
    }, _this._validateEffectiveDate = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var effectiveDateError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate);
          case 2:
            effectiveDateError = _context.sent;
            _context.next = 5;
            return _this.setState({
              effectiveDateError: effectiveDateError
            });
          case 5:
            if (!effectiveDateError) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", false);
          case 7:
            return _context.abrupt("return", true);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._saveBlueprint = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var effectiveDateValid, success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(_this.props.currentAccountMeta.state >= 3 && !_this.props.isMasterSite)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", null);
          case 2:
            if (!_this.props.isMasterSite) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return _this._validateEffectiveDate();
          case 5:
            effectiveDateValid = _context2.sent;
            if (effectiveDateValid) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", null);
          case 8:
            _context2.next = 10;
            return _this.props.saveModularBlueprint(_this.props.isMasterSite ? dates.getUTC(_this.state.effectiveDate) : null);
          case 10:
            success = _context2.sent;
            if (success) {
              _this.setState({
                unSavedChangesMade: false,
                effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
                showEffectiveDateDialog: false
              });
            }
            return _context2.abrupt("return", null);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._toggleEffectiveDateDialog = function () {
      _this.setState({
        showEffectiveDateDialog: !_this.state.showEffectiveDateDialog
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(ModularFlexDesignForm, _Component);
  return (0, _createClass2["default"])(ModularFlexDesignForm, [{
    key: "componentWillUnmount",
    value: (
    /**
     * On Unmount, clear the auto save and do a final save
     */
    function () {
      var _componentWillUnmount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var confirm;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.state.unSavedChangesMade) {
                _context3.next = 5;
                break;
              }
              confirm = window.confirm("Do you want to save your changes?");
              if (!confirm) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return this._saveDesign();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }
      return componentWillUnmount;
    }())
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        isMasterSite = _this$props.isMasterSite,
        currentAccountMeta = _this$props.currentAccountMeta;
      var whitelabel = this.props.whitelabel || {};
      var styles = {
        container: _theme.globalStyles.containerControlSite,
        content: _theme.globalStyles.content,
        contentBlock: _theme.globalStyles.contentBlock,
        saveBtn: {
          display: 'block',
          marginLeft: 'auto',
          marginTop: "20px !important"
        },
        header: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: "space-between"
        },
        headerTitleBlock: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        },
        backBtn: {
          minWidth: "30px",
          padding: "2px",
          marginRight: "5px",
          marginLeft: "-5px"
        },
        table: _objectSpread(_objectSpread({}, _theme.globalStyles.table), {}, {
          border: "2px solid #F1F1F1",
          backgroundColor: '#FFF'
        }),
        scrollbar: _theme.globalStyles.scrollbar,
        tableHeading: {
          paddingTop: 10,
          paddingBottom: 10,
          fontFamily: _theme.fonts.type.heading
        },
        tableCell: {
          paddingTop: 10,
          paddingBottom: 10,
          fontFamily: _theme.fonts.type.light
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerTitleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.backBtn,
        onClick: this.props.goBack,
        transparent: true
      }, /*#__PURE__*/_react["default"].createElement(_ArrowBackRounded["default"], null)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.buildAQuote))), (isMasterSite || this.props.currentAccountMeta.state <= 3) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: {
          height: 50,
          width: 180,
          fontSize: 16,
          textTransform: "capitalize"
        },
        onClick: function onClick() {
          // if we are saving a normal plan design from the master site then ask for an effective date
          if (isMasterSite && !_this2.props.isQuote && !_this2.props.isRevision) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._saveBlueprint();
          }
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.saveBlueprint))), this.props.selectedClass.description ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        tip: this.props.selectedClass.description,
        placement: "top",
        arrow: true,
        display: "inline-block"
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(this.props.selectedClass.title),
        isSelected: true,
        clickable: false
      })) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(this.props.selectedClass.title),
        isSelected: true,
        clickable: false
      }), !isMasterSite && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentAccountMeta.state === 4 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planDesignUnderReview)), currentAccountMeta.state === 5 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.reviewFinishedNoPricing)), currentAccountMeta.state > 5 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.acceptPricingNoChanges))), /*#__PURE__*/_react["default"].createElement(_ModularFlexForm["default"], {
        blueprint: this.props.blueprint,
        errors: this.state.errors,
        isMasterSite: isMasterSite,
        isRevision: this.props.isRevision,
        classID: this.props.classID,
        saveModularBenefitInitData: this.props.saveModularBenefitInitData,
        saveModularField: this.props.saveModularField,
        whitelabel: whitelabel,
        setChangesMadeFlag: this._setChangesMadeFlag,
        accountMeta: this.props.currentAccountMeta,
        isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor
      }), (isMasterSite || currentAccountMeta.state <= 3) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.saveBtn,
        onClick: function onClick() {
          // if we are saving a normal plan design from the master site then ask for an effective date
          if (isMasterSite && !_this2.props.isQuote && !_this2.props.isRevision) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._saveBlueprint();
          }
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.saveBlueprint))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showSaveMessageDialog,
        close: function close() {
          _this2.setState({
            showSaveMessageDialog: false,
            unSavedChangesMade: false
          });
        },
        title: _i18n["default"].t(_tokens["default"].labels.planDesign.changesMade),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!(isMasterSite && !_this2.props.isQuote && !_this2.props.isRevision)) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 3;
                return _this2._toggleEffectiveDateDialog();
              case 3:
                _context4.next = 7;
                break;
              case 5:
                _context4.next = 7;
                return _this2._saveBlueprint();
              case 7:
                _this2.setState({
                  showSaveMessageDialog: false
                });
              case 8:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        })),
        saveButtonText: "Save"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.unsavedChanges))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showEffectiveDateDialog,
        close: this._toggleEffectiveDateDialog,
        title: "Set Effective Date",
        onSave: this._saveBlueprint,
        saveButtonText: "Submit"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, "Please provide the date you would like the change(s) to be effective:"), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: "Effective Date",
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          _this2.setState({
            effectiveDate: e.target.value
          });
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, "By clicking Submit below, the changes made will be applied and effective on the date provided above. Back dated changes will have adjustments applied using current rates."), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = ModularFlexDesignForm;